export const filterDataSelector = ({worklistTableData: {filter = {}}}) => filter;
export const patientDataSelector = ({worklistTableData: {patientData = []}}) => patientData;
export const totalStudiesSelector = ({worklistTableData: {totalStudies = 0}}) => totalStudies